import { render, staticRenderFns } from "./TopOther.vue?vue&type=template&id=31e371ce&scoped=true&"
import script from "./TopOther.vue?vue&type=script&lang=js&"
export * from "./TopOther.vue?vue&type=script&lang=js&"
import style0 from "./TopOther.vue?vue&type=style&index=0&id=31e371ce&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e371ce",
  null
  
)

export default component.exports